import { combineReducers } from "redux";
import commonReducer from "../../commonReducer/commonReducer";
import drivingMarketParamsReducer from "../common/params";
import indexPullersDraggers from "./indexPullersDraggers";
export default combineReducers({
    reducersData: indexPullersDraggers,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
